import tagular from '../../util/tagular';

export const RECEIVE_FILTER_IN_ASSESSMENT = 'RECEIVE_FILTER_IN_ASSESSMENT';
export const RECEIVE_ONLY_FILTER_IN_ASSESSMENT = 'RECEIVE_ONLY_FILTER_IN_ASSESSMENT';
export const INITIALIZE_ASSESSMENT_FILTER_QUEUE = 'INITIALIZE_ASSESSMENT_FILTER_QUEUE';
export const REMOVE_FILTER_IN_ASSESSMENT = 'REMOVE_FILTER_IN_ASSESSMENT';
export const CLEAR_ALL_FILTERS_IN_ASSESSMENT = 'CLEAR_ALL_FILTERS_IN_ASSESSMENT';

/*
  single filter payload example:
  payload = {
    "promptId": 1,
    "filterVal": "filter1",
  }
*/

export const sendReceivedFilterEvent = (payload)=>(dispatch, getState)=>{
  const state = getState();

  sendAnswerSelectedEvent(state, payload);

  return dispatch(dispatchReceiveFilters(payload));
};

const getPillarName = () => {
  const {host} = window.location;
  const hostParts = host.split('.');

  const pillarMapping = {
      healthline: 2,
      medicalnewstoday: 5,
      greatist: 6,
      psychcentral: 7
  };

  for (const part of hostParts) {
      if (pillarMapping[part]) return part;
  }

  return 'healthline'
};

const sendAnswerSelectedEvent = (state, payload) => {

  const assessment = state.app.assessment;
  const inlineParentMetadata = state.inline.parentMetadata;
  const { question, id } = state.session.currentPrompt;

  const pillarName = getPillarName();

  let answer = payload.filterVal;

  if (payload.context) {
    answer = `${payload.context} - ${payload.filterVal}`;
  }

  const eventOptions = { question, answer, assessment, questionId: id, inlineParentMetadata, pillarName };

  tagular.sendFieldSelectedEvent(eventOptions);
}

export const receiveFilter = (payload) => (dispatchReceiveFilters(payload));

const dispatchReceiveFilters = (payload)=>{
  return {
      type: RECEIVE_FILTER_IN_ASSESSMENT,
      payload
  }
};

export const receiveOnlyFilter = (payload) => ({
    type: RECEIVE_ONLY_FILTER_IN_ASSESSMENT,
    payload
});

export const intitalizeFilterQueue = () => (dispatch, getState) => {
  const prompts = getState().entities.prompts;

  let initialState = {};

  for (let key of Object.keys(prompts)) {
    const prompt = prompts[key];
    const filterCount = prompt.filters.length;
    const filterQueue = new Array(filterCount).fill(null);

    initialState[key] = filterQueue;
  }

  return dispatch(dispatchIntitializeFilterQueue({initialState}));
};

const dispatchIntitializeFilterQueue = (payload) => {
  return {
    type: INITIALIZE_ASSESSMENT_FILTER_QUEUE,
    payload
  }
}

export const removeFilter = (payload) => ({
    type: REMOVE_FILTER_IN_ASSESSMENT,
    payload
});

export const clearAllFilters = () =>(dispatch)=>{
  dispatch({
      type: CLEAR_ALL_FILTERS_IN_ASSESSMENT
  });
};